import ObjectUtils from './ObjectUtils';
import { I18n } from 'react-redux-i18n';


export const translateError = (platformModule = '', httpErrorCode = '500', reason = '') => {
    if (ObjectUtils.isNilOrEmpty(platformModule) || !errorKeys.hasOwnProperty(platformModule)) return I18n.t('errors.applicationError');

    let errorKeysArray = [];

    if(errorKeys[platformModule].hasOwnProperty(httpErrorCode)) {
        if(errorKeys[platformModule][httpErrorCode] instanceof Object) {
            if(errorKeys[platformModule][httpErrorCode].hasOwnProperty(reason)) {
                errorKeysArray.push(errorKeys[platformModule][httpErrorCode][reason]);
            } else {
                errorKeysArray.push('generic');
            }
        } else {
            errorKeysArray.push(errorKeys[platformModule][httpErrorCode]);
        }
    } else {
        errorKeysArray.push('generic');
    }
    return I18n.t(platformModule + '.errors.' + errorKeysArray.join('.'));
}

export const translateErrorWithKey = (platformModule = '', key = '') => {
    if (ObjectUtils.isNilOrEmpty(platformModule) || !errorKeys.hasOwnProperty(platformModule)) return I18n.t('errors.applicationError');
    return I18n.t(platformModule + '.errors.' + key);
}


const errorKeys = {
    auth: {
        401: 'invalidCredentials',
        404: 'userNotFound',
        409: {
            USER_INACTIVE: 'userInactive'
        },
        412: 'userCredentialsExpired',
        417: 'userBlocked',
        429: 'tooManyRequests'
    },
    users: {
        409: {
            USER_EMAIL_ALREADY_EXISTS: 'userEmailAlreadyExists',
            USER_EMAIL_INVALID: 'userEmailInvalid',
            USER_NAME_INVALID: 'userNameInvalid',
            USER_ACCOUNT_ALREADY_ACTIVATED: 'userAccountAlreadyActivated',
            USER_HAS_AUDIT_ENTRIES: 'userHasAuditEntries',
            USER_INACTIVE: 'userInactive'
        }
    },
    roles: {
        409: {
            ROLE_NAME_ALREADY_EXISTS: 'roleNameAlreadyExists',
            ROLE_HAS_USERS_ASSIGNED: 'roleHasUsersAssigned'
        }
    },
    entities: {
        409: {
            ENTITY_HAS_DEPENDENCIES: 'entitiesHasDependencies'
        }
    },
    meetingRooms: {
        409: {
            MEETING_ROOM_DOES_NOT_ALLOW_QUICK_BOOK: 'meetingRoomNoQuickBook',
            EMAIL_ALREADY_IN_USE: 'emailAlreadyInUse'
        }
    }
}